import {
  successNotifyService,
  failureNotifyService,
} from "@/services/errors.service.js";
import { isInteger } from "core-js/fn/number";
import { isBoolean } from "lodash";

export function checkInputFieldService(localData, action) {
  let cfObj = {};

  //////////////////////////////////////
  /// Contact Component
  //////////////////////////////////////

  if (action === "savePersonalWebsite") {
    cfObj.fieldName = "personalWebsite";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "users";
    cfObj.vuexServiceName = "users";
    return cfObj;
  } else if (action === "saveSkypeProfile") {
    cfObj.fieldName = "skypeProfile";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "users";
    cfObj.vuexServiceName = "users";
    return cfObj;
  } else if (action === "saveFacebookProfile") {
    cfObj.fieldName = "facebookProfile";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "users";
    cfObj.vuexServiceName = "users";
    return cfObj;
  } else if (action === "saveContactNumber") {
    cfObj.fieldName = "contactNumber";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "users";
    cfObj.vuexServiceName = "users";
    return cfObj;
  } else if (action === "saveTwitterProfile") {
    cfObj.fieldName = "twitterProfile";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "users";
    cfObj.vuexServiceName = "users";
    return cfObj;
  } else if (action === "saveAddress") {
    cfObj.fieldName = "address";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "users";
    cfObj.vuexServiceName = "users";
    return cfObj;
  } else if (action === "saveLinkedinProfile") {
    cfObj.fieldName = "linkedinProfile";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "users";
    cfObj.vuexServiceName = "users";
    return cfObj;
  } else if (action === "saveDiscordProfile") {
    cfObj.fieldName = "discordProfile";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "users";
    cfObj.vuexServiceName = "users";
    return cfObj;
  } else if (action === "saveCareerObjective" && localData.careerObjective) {
    cfObj.fieldName = "careerObjective";
    cfObj.fieldValueIsNull = false;
    cfObj.collectionName = "users";
    cfObj.vuexServiceName = "users";
    return cfObj;
  } else {
    cfObj.fieldName = null;
    cfObj.fieldValueIsNull = true;
    cfObj.collectionName = null;
    cfObj.vuexServiceName = null;
    return cfObj;
  }
}

export function saveInputFieldService(payload) {
  const isUserLoggedIn = payload.isUserLoggedIn;
  const action = payload.action;
  const currentThis = payload.currentThis;
  const localData = payload.localData;
  const userId = payload.userId;

  const cfObj = checkInputFieldService(localData, action);

  console.log("local", localData);

  if (!isUserLoggedIn || cfObj.fieldValueIsNull) {
    return;
  }

  currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

  //// console.log("executing...", localData);

  const fieldName = cfObj.fieldName;
  const vuexServiceName = cfObj.vuexServiceName;

  const dataObj = {};
  dataObj["_id"] = userId;
  dataObj["collectionName"] = cfObj.collectionName;

  if (localData[`${fieldName}`]) {
    // If field value is not null

    if (isInteger(localData[`${fieldName}`])) {
      dataObj[`${fieldName}`] = Number(
        localData[`${fieldName}`].toString().trim()
      );
    }
    if (isBoolean(localData[`${fieldName}`])) {
      dataObj[`${fieldName}`] = Boolean(
        localData[`${fieldName}`].toString().trim()
      );
    } else {
      dataObj[`${fieldName}`] = localData[`${fieldName}`].trim();
    }
  } else dataObj[`${fieldName}`] = null; // If field value is null

  // // console.log(dataObj);

  currentThis.$store
    .dispatch(`${vuexServiceName}/${action}`, dataObj)
    .then((res) => {
      currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", false);
      //// console.log(res);
    })
    .catch((err) => {
      throw err;
    });
}
